export default "__VITE_ASSET__Bv4V1GnO__"